import { render, staticRenderFns } from "./SensorBlock.vue?vue&type=template&id=04bfe5c8&"
import script from "./SensorBlock.vue?vue&type=script&lang=js&"
export * from "./SensorBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports